import h from "./index47.js";
import f from "./index127.js";
import { isString as v, DIRECTION as o, objectIncludes as V, forceDirection as I } from "./index125.js";
import _ from "./index46.js";
class p {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(t) {
    this._value = "", this._update({
      ...p.DEFAULTS,
      ...t
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(t) {
    this.optionsIsChanged(t) && this.withValueRefresh(this._update.bind(this, t));
  }
  /** Sets new options */
  _update(t) {
    Object.assign(this, t);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(t) {
    this._value = t._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(t) {
    this.resolve(t, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(t, e) {
    e === void 0 && (e = {
      input: !0
    }), this.reset(), this.append(t, e, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(t) {
    this.resolve(t, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(t) {
    this.format ? this.value = this.format(t, this) : this.unmaskedValue = String(t);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(t) {
    this.resolve(t, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(t, e) {
    return t;
  }
  totalInputPositions(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), Math.min(this.displayValue.length, e - t);
  }
  /** Extracts value in range considering flags */
  extractInput(t, e, i) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), this.displayValue.slice(t, e);
  }
  /** Extracts tail in range */
  extractTail(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), new f(this.extractInput(t, e), t);
  }
  /** Appends tail */
  appendTail(t) {
    return v(t) && (t = new f(String(t))), t.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(t, e) {
    return t ? (this._value += t, new h({
      inserted: t,
      rawInserted: t
    })) : new h();
  }
  /** Appends char */
  _appendChar(t, e, i) {
    e === void 0 && (e = {});
    const s = this.state;
    let a;
    if ([t, a] = this.doPrepareChar(t, e), t && (a = a.aggregate(this._appendCharRaw(t, e)), !a.rawInserted && this.autofix === "pad")) {
      const n = this.state;
      this.state = s;
      let r = this.pad(e);
      const l = this._appendCharRaw(t, e);
      r = r.aggregate(l), l.rawInserted || r.equals(a) ? a = r : this.state = n;
    }
    if (a.inserted) {
      let n, r = this.doValidate(e) !== !1;
      if (r && i != null) {
        const l = this.state;
        if (this.overwrite === !0) {
          n = i.state;
          for (let d = 0; d < a.rawInserted.length; ++d)
            i.unshift(this.displayValue.length - a.tailShift);
        }
        let u = this.appendTail(i);
        if (r = u.rawInserted.length === i.toString().length, !(r && u.inserted) && this.overwrite === "shift") {
          this.state = l, n = i.state;
          for (let d = 0; d < a.rawInserted.length; ++d)
            i.shift();
          u = this.appendTail(i), r = u.rawInserted.length === i.toString().length;
        }
        r && u.inserted && (this.state = l);
      }
      r || (a = new h(), this.state = s, i && n && (i.state = n));
    }
    return a;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new h();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new h();
  }
  /** Appends symbols considering flags */
  append(t, e, i) {
    if (!v(t))
      throw new Error("value should be string");
    const s = v(i) ? new f(String(i)) : i;
    e != null && e.tail && (e._beforeTailState = this.state);
    let a;
    [t, a] = this.doPrepare(t, e);
    for (let n = 0; n < t.length; ++n) {
      const r = this._appendChar(t[n], e, s);
      if (!r.rawInserted && !this.doSkipInvalid(t[n], e, s))
        break;
      a.aggregate(r);
    }
    return (this.eager === !0 || this.eager === "append") && e != null && e.input && t && a.aggregate(this._appendEager()), s != null && (a.tailShift += this.appendTail(s).tailShift), a;
  }
  remove(t, e) {
    return t === void 0 && (t = 0), e === void 0 && (e = this.displayValue.length), this._value = this.displayValue.slice(0, t) + this.displayValue.slice(e), new h();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(t) {
    if (this._refreshing || !this._initialized)
      return t();
    this._refreshing = !0;
    const e = this.rawInputValue, i = this.value, s = t();
    return this.rawInputValue = e, this.value && this.value !== i && i.indexOf(this.value) === 0 && (this.append(i.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, s;
  }
  runIsolated(t) {
    if (this._isolated || !this._initialized)
      return t(this);
    this._isolated = !0;
    const e = this.state, i = t(this);
    return this.state = e, delete this._isolated, i;
  }
  doSkipInvalid(t, e, i) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(t, e) {
    return e === void 0 && (e = {}), h.normalize(this.prepare ? this.prepare(t, this, e) : t);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(t, e) {
    return e === void 0 && (e = {}), h.normalize(this.prepareChar ? this.prepareChar(t, this, e) : t);
  }
  /** Validates if value is acceptable */
  doValidate(t) {
    return (!this.validate || this.validate(this.value, this, t)) && (!this.parent || this.parent.doValidate(t));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(t, e, i, s, a) {
    i === void 0 && (i = ""), s === void 0 && (s = o.NONE), a === void 0 && (a = {
      input: !0
    });
    const n = t + e, r = this.extractTail(n), l = this.eager === !0 || this.eager === "remove";
    let u;
    l && (s = I(s), u = this.extractInput(0, n, {
      raw: !0
    }));
    let d = t;
    const g = new h();
    if (s !== o.NONE && (d = this.nearestInputPos(t, e > 1 && t !== 0 && !l ? o.NONE : s), g.tailShift = d - t), g.aggregate(this.remove(d)), l && s !== o.NONE && u === this.rawInputValue)
      if (s === o.FORCE_LEFT) {
        let w;
        for (; u === this.rawInputValue && (w = this.displayValue.length); )
          g.aggregate(new h({
            tailShift: -1
          })).aggregate(this.remove(w - 1));
      } else
        s === o.FORCE_RIGHT && r.unshift();
    return g.aggregate(this.append(i, a, r));
  }
  maskEquals(t) {
    return this.mask === t;
  }
  optionsIsChanged(t) {
    return !V(this, t);
  }
  typedValueEquals(t) {
    const e = this.typedValue;
    return t === e || p.EMPTY_VALUES.includes(t) && p.EMPTY_VALUES.includes(e) || (this.format ? this.format(t, this) === this.format(this.typedValue, this) : !1);
  }
  pad(t) {
    return new h();
  }
}
p.DEFAULTS = {
  skipInvalid: !0
};
p.EMPTY_VALUES = [void 0, null, ""];
_.Masked = p;
export {
  p as default
};
